import { render, staticRenderFns } from "./Tournament2025.vue?vue&type=template&id=e6b6e71e&scoped=true"
import script from "./Tournament2025.vue?vue&type=script&lang=js"
export * from "./Tournament2025.vue?vue&type=script&lang=js"
import style0 from "./Tournament2025.vue?vue&type=style&index=0&id=e6b6e71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b6e71e",
  null
  
)

export default component.exports